import { defineComponent as _defineComponent } from 'vue'
import BaseIcon from './BaseIcon.vue'
  interface Props {
    color?: string,
    size?: number,
    width?: number,
    height?: number
  }


export default /*#__PURE__*/_defineComponent({
  __name: 'VK',
  props: {
    color: { default: '#292929' },
    size: { default: 24 },
    width: { default: 0 },
    height: { default: 0 }
  },
  setup(__props: any) {




return { __sfc: true,BaseIcon }
}

})